/**
 * Payment note of the scooter booking summary: what is paid, when and to
 * whom. Nothing is paid on Ridalo; the deposit goes to the provider after
 * confirmation; the delivery + collection fee of the chosen zone is paid
 * on-site at delivery (« offered » when 0 THB); any security deposit on-site.
 * Returns i18n keys (under scooters.detail.booking.paymentNote) and params.
 */
export const paymentNoteLines = ({ depositPct = 0, deliveryFee = null, formatFee = String } = {}) => {
  const lines = [['noPayment'], [depositPct > 0 ? 'deposit' : 'noDeposit']];
  if (deliveryFee != null && Number.isFinite(Number(deliveryFee))) {
    lines.push(Number(deliveryFee) > 0 ? ['delivery', { fee: formatFee(Number(deliveryFee)) }] : ['deliveryFree']);
  }
  lines.push(['caution']);
  return lines;
};
